var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53516 3.16016C6.39844 3.02344 6.19336 3.03711 6.05664 3.16016L4.48438 4.81445L4.48438 0.890625C4.48438 0.699219 4.34766 0.5625 4.15625 0.5625L3.71875 0.5625C3.54102 0.5625 3.39063 0.699218 3.39063 0.890625L3.39063 4.81445L1.83203 3.17383C1.69531 3.03711 1.49023 3.03711 1.35352 3.16016L1.05273 3.46094C0.929688 3.59766 0.929688 3.80273 1.05273 3.92578L3.71875 6.5918C3.8418 6.71484 4.04688 6.71484 4.16992 6.5918L6.83594 3.92578C6.95898 3.80273 6.95898 3.59766 6.83594 3.46094L6.53516 3.16016Z",
    fill: "#B50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.b40f4f1bc402714a9b7af672f86d5370.svg";
export { ForwardRef as ReactComponent };